import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken,removeToken } from '@/utils/token'

NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register']

function getSsoToken(to) {
    if (to && to.query && to.query.sso_token) {
        return to.query.sso_token
    }
    const searchToken = new URLSearchParams(window.location.search || '').get('sso_token')
    return searchToken || ''
}

function buildRedirectPath(to) {
    if (!to) {
        return '/'
    }
    const query = { ...(to.query || {}) }
    delete query.sso_token
    const queryString = new URLSearchParams(query).toString()
    return queryString ? `${to.path}?${queryString}` : to.path
}

function normalizeRoutePath(path) {
    if (!path) {
        return '/'
    }
    return path.startsWith('/') ? path : `/${path}`
}

function isSpecialRoute(path) {
    return path === '/403' || path === '/404'
}

function isCatchAllRoute(path) {
    return !!path && path.includes(':pathMatch')
}

function getFirstAccessiblePath(routes) {
    const routeList = routes || []
    for (let i = 0; i < routeList.length; i++) {
        const route = routeList[i]
        const childPath = getFirstAccessiblePath(route.children)
        if (childPath) {
            return childPath
        }

        const routePath = normalizeRoutePath(route.path || '')
        if (routePath !== '/' && !isSpecialRoute(routePath) && !isCatchAllRoute(route.path)) {
            return routePath
        }
    }
    return '/index'
}

function hasRoutePath(routes, targetPath) {
    const routeList = routes || []
    const normalizedTargetPath = normalizeRoutePath(targetPath)
    for (let i = 0; i < routeList.length; i++) {
        const route = routeList[i]
        const currentPath = normalizeRoutePath(route.path || '')
        if (currentPath === normalizedTargetPath) {
            return true
        }
        if (route.children && hasRoutePath(route.children, normalizedTargetPath)) {
            return true
        }
    }
    return false
}

function resolveAuthorizedPath(to, routes) {
    const currentPath = normalizeRoutePath((to && to.path) || '/')
    if (isSpecialRoute(currentPath)) {
        return currentPath
    }

    const homePath = getFirstAccessiblePath(routes)
    if (currentPath === '/') {
        return homePath
    }
    if (hasRoutePath(routes, currentPath)) {
        return currentPath
    }
    return homePath
}

function loadDynamicRoutes() {
    const cachedRoutes = store.getters['menu/getRoutes'] || []
    const needLoadRoutes = cachedRoutes.length === 0
    if (!needLoadRoutes) {
        return Promise.resolve({
            accessRoutes: cachedRoutes,
            loaded: false
        })
    }

    return store.dispatch('menu/generateRoutes').then(accessRoutes => {
        router.addRoutes(accessRoutes)
        return {
            accessRoutes,
            loaded: true
        }
    })
}

router.beforeEach((to, from, next) => {
    NProgress.start()
    const token = getToken()

    if (!token) {
        // 没有令牌 - 检查是否在免登录白名单
        if (whiteList.indexOf(to.path) !== -1) {
            // 在免登录白名单，直接进入
            next()
        } else {
            // 不在白名单且没有令牌
            const ssoToken = getSsoToken(to)
            if (ssoToken) {
                // 有SSO令牌，跳转到登录页进行令牌交换
                const query = { sso_token: ssoToken }
                const redirect = buildRedirectPath(to)
                if (redirect && redirect !== '/login') {
                    query.redirect = redirect
                }
                next({ path: '/login', query })
            } else {
                // 无SSO令牌，回到当前管理端登录页
                next({ path: '/login' })
            }
            NProgress.done()
        }
    } else {
        // 有令牌，继续正常流程
        loadDynamicRoutes().then(({ accessRoutes, loaded }) => {
            const targetPath = to.path === '/login'
                ? getFirstAccessiblePath(accessRoutes)
                : resolveAuthorizedPath(to, accessRoutes)

            if (to.path === '/login' || targetPath !== normalizeRoutePath(to.path)) {
                next({ path: targetPath, replace: true })
                return
            }

            if (loaded) {
                next({ ...to, replace: true })
                return
            }

            next()
        }).catch(err => {
            // 检查是否是 token 失效等特殊错误，这些错误已经在 request 拦截器中处理过了
            const errorMsg = err.message || ''
            const isTokenError = errorMsg.includes('令牌') || errorMsg.includes('过期') || errorMsg.includes('权限')

            if (!isTokenError) {
                // 不是 token 失效等特殊错误，才显示错误提示
                Message.error(err)
            }

            store.dispatch('user/logout').then(() => {
                store.commit("menu/setMenus",[])
                store.commit("menu/setRoutes",[])
                store.commit("menu/setDisplayMenus",[])
                store.commit("menu/setBtnMenus",[])
                store.commit('menu/setActiveMenuArrary', [])
                store.commit('menu/setActiveMenu', "/index")
                removeToken()
                next('/login')
            })
        })
    }
})

router.afterEach(() => {
    NProgress.done()
})
